import { render, staticRenderFns } from "./show_result.vue?vue&type=template&id=6978a6c1&"
import script from "./show_result.vue?vue&type=script&lang=js&"
export * from "./show_result.vue?vue&type=script&lang=js&"
import style0 from "./show_result.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports